<template>
  <v-card outlined class="pa-4 ma-0" style="height: 300px">
    <!-- Header -->
    <v-container class="pa-0 ma-0 d-flex justify-space-between align-center mb-4">
      <v-card-text class="pa-0 ma-0 text-body-2">
        {{ $t("recent_activities") }}
      </v-card-text>
      <v-icon small color="grey">mdi-clock-outline</v-icon>
    </v-container>

    <!-- Timeline -->
    <v-container class="pa-0 ma-0 scroll-y timeline">
      <v-container
        v-for="(item, index) in activities"
        :key="index"
        class="pa-0 ma-0 d-flex align-start mb-4 timeline-row"
      >
        <!-- Dot + line -->
        <v-container class="pa-0 ma-0 timeline-indicator">
          <span class="timeline-dot" :style="{ backgroundColor: item.color }"></span>
        </v-container>

        <!-- Content -->
        <v-container class="pa-0 ma-0">
          <v-card-text class="pa-0 ma-0 text-body-2">
            {{ item.title }}
          </v-card-text>

          <v-card-text class="pa-0 ma-0 text-caption grey--text">
            {{ item.subtitle }}
          </v-card-text>
        </v-container>

        <!-- Time -->
        <v-container class="pa-0 ma-0 text-body-2 grey--text" style="width: 95px">
          {{ item.time }}
        </v-container>
      </v-container>
    </v-container>
  </v-card>
</template>
<script>
export default {
  name: "RecentActivities",

  data() {
    return {
      activities: [
        {
          time: "۵ دقیقه پیش",
          title: "فاکتور فروش جدید ثبت شد",
          subtitle: "شماره فاکتور: ۱۲۳۰۰",
          color: "#4CAF50",
        },
        {
          time: "۱۲ دقیقه پیش",
          title: "سفارش خرید تایید شد",
          subtitle: "روش پرداخت: آنلاین",
          color: "#2196F3", 
        },
        {
          time: "۳۰ دقیقه پیش",
          title: "بازپرداخت انجام شد",
          subtitle: "وضعیت: موفق",
          color: "#9C27B0",
        },
        {
          time: "۱ ساعت پیش",
          title: "موجودی انبار به‌روز شد",
          subtitle: "انبار مرکزی",
          color: "#FF9800",
        },
      ],
    };
  },
};
</script>
<style scoped>
.scroll-y {
  overflow-y: auto;
  scrollbar-width: none;
}
.scroll-y::-webkit-scrollbar {
  display: none;
}

.timeline-row {
  position: relative;
}

.timeline-indicator {
  width: 16px;
  margin-left: 12px;
  position: relative;
}

.timeline-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: block;
  margin-top: 4px;
}
.timeline-indicator::after {
  content: "";
  position: absolute;
  top: 16px;
  right: 3px;
  width: 1px;
  height: calc(100% - 16px);
  background-color: #e0e0e0;
}
</style>
